import styled from 'styled-components'

export const H2 = styled.h2`
color: var(--space-cadet-2);
line-height: 1.3;
font-weight: var(--fw-800);
font-size: var(--fs-2)
`

export const H2Home = styled.h2`
color: var(--space-cadet-2);
line-height: 1.3;
font-weight: var(--fw-800);
font-size: var(--fs-1);
margin-block-end: 25px
`
export const H2Courses = styled.h2`
color: var(--space-cadet-2);
line-height: 1.3;
font-weight: var(--fw-800);
font-size: var(--fs-2);

margin-block: 40px;
text-align: center;
`

export const H2Planning = styled.h2`
color: var(--space-cadet-2);
line-height: 1.3;
font-weight: var(--fw-800);
font-size: var(--fs-2);

margin-block: 60px;
text-align: center;
`
export const H2Inscript = styled.h2`
color: var(--old-lavender);
font-weight: var(--fw-200);
font-size: 3rem;
margin-block-end: 15px;
text-align: center;
`

export const H2Form = styled.h2`
color: var(--space-cadet-2);
line-height: 1.3;
font-weight: var(--fw-600);
font-size: var(--fs-2);
margin-block-end: 20px;

text-align: center;
`
